import { ButtonHTMLAttributes, ReactNode, forwardRef } from "react";
import ReactLoading from "react-loading";
import * as S from "./styles";

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: "ghost" | "gray";
  children: ReactNode;
  isLoading?: boolean;
  loadingColor?: string;
}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ variant, children, isLoading, loadingColor, ...rest }, ref) => {
    return (
      <S.ButtonContainer
        ref={ref}
        variant={variant}
        disabled={isLoading}
        {...rest}
      >
        {isLoading ? (
          <ReactLoading
            height={25}
            width={25}
            type={"spin"}
            color={loadingColor || "#ffffff"}
          />
        ) : (
          children
        )}
      </S.ButtonContainer>
    );
  },
);
